import { withCompInfo } from '@wix/editor-elements-integrations'
import { ItunesButtonCSSVars, ItunesButtonDefinition } from './ItunesButton'
import { getWidthPixelValue } from '@wix/editor-elements-common-utils'

export const css = withCompInfo<ItunesButtonCSSVars, ItunesButtonDefinition>()(
	['compLayout', 'compSingleLayout'],
	({ compLayout, compSingleLayout }) => {
		const width = getWidthPixelValue(compLayout, compSingleLayout)
		return {
			height: `${(width! * 40) / 110}px`,
		}
	}
)
